import styled, { css } from 'styled-components';

import { basicTransition, Heading, StyledFlex } from '@dreryk/react-components';

export const StyledEducationalMaterialCard = styled.div`
   ${basicTransition};
   flex: 0 0 auto;
   width: 300px;
   border-radius: 16px;
   overflow: hidden;
   cursor: pointer;
   ${({ theme }) => css`
      border: 2px solid ${theme.borderLight};
   `}

   &:hover {
      ${({ theme }) => css`
         border-color: ${theme.primaryDark};
      `}
   }
`;

StyledEducationalMaterialCard.displayName = 'StyledEducationalMaterialCard';

export const StyledImage = styled.img`
   width: 100%;
   height: 300px;
   object-fit: cover;
   display: block;
   border-bottom-left-radius: 16px;
   border-bottom-right-radius: 16px;
   ${({ theme }) => css`
      border-bottom: 2px solid ${theme.borderLight};
   `}
`;

StyledImage.displayName = 'StyledImage';

export const StyledContent = styled(StyledFlex)`
   padding: 12px 16px;
`;

StyledContent.displayName = 'StyledContent';

export const StyledHeading = styled(Heading)`
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;

StyledHeading.displayName = 'StyledHeading';

export const StyledAuthors = styled.div`
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;

StyledAuthors.displayName = 'StyledAuthors';
